<%
var component = new Anvil.models.components.FormArray({
	prefix,
	data,
	name,
	placeholder,
	fields,
	model,
	update: (typeof update == 'function') ? update : null,
})
%>
<div anvil-component="<%- component.id %>">
	<div id="<%- component.id %>_array_area">
		<%- include('form/form_array_area', { array: data[name], name_prefix: `${prefix}_${name}`, placeholder, fields }) %>
	</div>
	<% if (!(typeof fixed == 'boolean' && fixed == true)) { %>
	<div class="text-end mb-2">
		<button type="button" id="<%- component.id %>_add_btn" class="btn btn-success text-light"><i class="fa fa-plus me-2"></i>Új sor</button>
	</div>
	<% } %>
</div>
